<template>
  <FieldWrapper
    :label="label"
    :state="state"
    :configs="configs"
  >
    <div class="column full-width">
      <div class="col">
        <DatePicker
          v-model="timestamp"
          :placeholder="placeholder"
          :disabled="disabled"
          :type="inputType"
          value-type="timestamp"
          :lang="langPtBR"
          :format="format"
        />
      </div>
    </div>
  </FieldWrapper>
</template>

<script>
import FieldWrapper from './FieldWrapper'
import DatePicker from 'vue2-datepicker'
import langPtBR from 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'

const TIME_FORMAT = 'TIME_FORMAT'
const DATE_TIME_FORMAT = 'DATE_TIME_FORMAT'

export default {
  components: {
    DatePicker,
    FieldWrapper
  },

  props: {
    value: {},
    state: {},
    label: {},
    configs: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    let timestamp = toTimestamp(this.value)
    if (timestamp) timestamp *= 1000

    return {
      langPtBR,
      timestamp
    }
  },

  computed: {
    format () {
      const { fieldTypeInput } = this.configs
      if (fieldTypeInput === TIME_FORMAT) return 'HH:mm:ss'
      if (fieldTypeInput === DATE_TIME_FORMAT) return 'DD/MM/YY HH:mm'
      return 'DD/MM/YYYY'
    },

    placeholder () {
      return this.configs?.placeholder
    },

    inputType () {
      const { fieldTypeInput } = this.configs
      if (fieldTypeInput === TIME_FORMAT) return 'time'
      if (fieldTypeInput === DATE_TIME_FORMAT) return 'datetime'
      return 'date'
    }
  },

  watch: {
    value: {
      deep: true,
      handler (value) {
        let timestamp = toTimestamp(value)
        if (timestamp) timestamp *= 1000
        if (this.timestamp === timestamp) return
        this.timestamp = timestamp
      }
    },

    timestamp: {
      deep: true,
      handler (timestamp) {
        const value = timestamp ? Math.floor(timestamp / 1000) : null
        if (this.value === value) return
        this.$emit('input', value)
      }
    }
  }
}

const toTimestamp = (val) => {
  if (!val) return null
  if (typeof val === 'number') return val
  if (val?.getTime()) return Math.floor(val.getTime() / 1000)
  if (isNaN(val)) return null
  return Number(val)
}
</script>
